export const downloadFromLink = (link: string, title: string, newWindow?: boolean) => {
    const a = document.createElement("a");
    a.href = link;
    a.download = title;
    if (newWindow) {
        a.target = "_blank";
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};
